import { FunctionComponent } from "react";
import { Collapsible } from "../../../components/basic/Collapsible";

const Criteria: FunctionComponent = () => {
  return (
    <div className="page-title mt-4">
      <div className="mt-4">
        <Collapsible
          text="Classic Credit - Show Criteria"
          graphic="content_paste"
        >
          <div className="p-4 rounded-md text-left border mt-4">
            <p className="text-sm font-bold">
              New Reg have teamed up with V12 Retail Finance to offer flexible finance
              options for your dream private number plate.
            </p>
            <p className="font-bold mt-4 text-sm">
              The minimum criteria to be eligible for a loan with V12 Retail Finance are:
            </p>
            <p className="mt-4 text-sm">* You must be over 18 years of age.</p>
            <p className="mt-4 text-sm">
              * You must be employed at least 16 hours per week, self-employed,
              retired in receipt of a pension or receiving disability payments.
            </p>
            <p className="mt-4 text-sm">
              * You must be a permanent UK resident with at least 3 years UK
              address history.
            </p>
            <p className="mt-4 text-sm">
              * You must have a good credit history with no late payments, debt
              relief orders, CCJs, IVAs or bankruptcies.
            </p>
            <p className="mt-4 text-sm">
              * You must have an active valid email address.
            </p>
            <div className="mt-4 text-xs text-gray-500">
              <p className="">
                New Reg is a trading name of New Reg Limited registered in
                England & Wales, registration number 03143909. Registered office
                address is New Reg, Unit 5, 117 Liverpool Road, Longton,
                Preston, PR4 5AA. [Contact Telephone Number] & [email address].
              </p>
              <p className="mt-4">
                New Reg is authorised and regulated by the Financial Conduct
                Authority, FCA registration number 626225.
              </p>
              <p className="mt-4">
                New Reg Limited trading as New Reg acts as a credit broker and
                is not a lender, introducing customers to Etika Finance UK Ltd.
              </p>
              <p className="mt-4">
                V12 Retail Finance Limited is a company registered in England and Wales 4585692 and authorised and
                regulated by the Financial Conduct Authority, registration
                number: 679653.
              </p>
              <p className="mt-4">
                Registered address: WeWork, No.1 Spinningfields, Quay Street,
                Manchester, M3 3JE.
              </p>
            </div>
            <div className="mt-4 text-center text-xs text-gray-500">
              <p className="">
                Web:{" "}
                <a href="https://www.v12retailfinance.com" style={{ color: "#005984" }}>
                  www.v12retailfinance.com
                </a>
              </p>
              <p className="mt-2">
                FAQs:{" "}
                <a
                  href="https://www.v12retailfinance.com/customer/faqs"
                  style={{ color: "#005984" }}
                >
                  https://www.v12retailfinance.com/customer/faqs
                </a>
              </p>
              <p className="mt-2">
                Email:{" "}
                <a
                  href="mailto:customerservices@v12finance.com"
                  style={{ color: "#005984" }}
                >
                  customerservices@v12finance.com
                </a>
              </p>
              <p className="mt-2">
                Tel:{" "}
                <a href="tel:+44 2920 468900" style={{ color: "#005984" }}>
                  02920 468 900
                </a>
              </p>
            </div>
          </div>
        </Collapsible>
      </div>
    </div>
  );
};

export { Criteria, Criteria as default };
